<template>
    <section>
        <Sidebar />
        <Content class="create-endpoint-page">
            <h1><i class="fas fa-user" style="margin-right: 7px;"></i> Profile</h1>
            <template v-if="loading">
                <img src="/img/loading-devect.gif" style="width: 100px; height: 100px; position: absolute; top: 50%; left: 50%; margin-left: 90px; margin-top: -50px;">
            </template>
            <template v-else>
                <div class="row">
                    <div class="col-sm-6">
                        <b-field label="First name">
                            <b-input
                                placeholder="First name"
                                type="text"
                                icon-pack="fas"
                                required
                                pattern=".{2,30}"
                                ref="first_name"
                                validation-message="Must have at least 2 characters"
                                icon="user"
                                v-model="user.first_name">
                            </b-input>
                        </b-field>
                        <b-field label="Last name">
                            <b-input
                                placeholder="Last name"
                                type="text"
                                icon-pack="fas"
                                required
                                pattern=".{2,30}"
                                ref="last_name"
                                validation-message="Must have at least 2 characters"
                                icon="user"
                                v-model="user.last_name">
                            </b-input>
                        </b-field>
                        <b-field label="Email">
                            <b-input placeholder="Email"
                                type="email"
                                icon-pack="fas"
                                required
                                ref="email"
                                icon="envelope" v-model="user.email">
                            </b-input>
                        </b-field>
                        <b-button type="is-primary" style="margin-top: 35px; float: right;" @click="_updateUser()">Save profile</b-button>
                    </div>
                </div>
            </template>
        </Content>
    </section>
</template>

<script>
import Sidebar from "../components/sidebar/Sidebar"
import Content from "../components/Content"
import {getJWTContent, getUserPlan} from "../logic/global"
import constants from '../constants'
import {updateUser, getUser} from '../logic/account'

let user = {
    "first_name": "",
    "last_name": "",
    "email": ""
}

export default {
    name: 'Profile',
    components: {Sidebar, Content},
    data() {
        return {
            user: user,
            loading: true
        }
    },
    methods: {
        showSuccessMsg: function(message, msg_type){
            this.$buefy.toast.open({message: message, type: msg_type})
        },
        _updateUser: function(){
            let user_id = getJWTContent()["id"]
            let isNameValid = this.$refs.first_name.checkHtml5Validity()
            let isLastNameValid = this.$refs.last_name.checkHtml5Validity()
            let isEmailValid = this.$refs.email.checkHtml5Validity()

            if(!isEmailValid){
                this.showSuccessMsg("Email is not valid", "is-danger")
            }

            if(!isNameValid){
                this.showSuccessMsg("'First name' must have at least 2 characters", "is-danger")
            }

            if(!isLastNameValid){
                this.showSuccessMsg("'Last name' must have at least 2 characters", "is-danger")
            }

            if(isEmailValid && isNameValid && isLastNameValid){
                updateUser(user_id, this.user).then(response => {
                    this.showSuccessMsg("Profile updated successfully", "is-success")
                }).catch(error => {
                    this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                })
            }else{
                console.log(isNameValid)
                console.log(isLastNameValid)
                console.log(isEmailValid)
            }
        }
    },
    mounted: function(){
        let user_id = getJWTContent()["id"]
        getUser(user_id).then(response => {
            this.user = response.data
            this.loading = false
        }).catch(error => {
            this.showSuccessMsg("Something went wrong. We could not load your profile.", "is-danger")
        })
    }
}
</script>

<style scoped>
  h1{margin-bottom: 24px;}
</style>